import React from 'react';
import { FormattedMessage } from 'react-intl';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';

type Props = {
  password: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

type State = {
  seePassword: boolean;
};

export class SignUpFormPassword extends React.Component<Props, State> {
  state: State = {
    seePassword: false,
  };

  toggleSeeClearPassword = () => {
    doctrineAnalytics('Account SeePasswordToggle', { source: 'signup' });
    this.setState(({ seePassword }) => ({
      seePassword: !seePassword,
    }));
  };

  render() {
    return (
      <label htmlFor="input-password" className="signup-form__label">
        <div className="signup-form__label__group">
          <div>
            <FormattedMessage id="signup/routes/user/form/SignUpFormPassword.tsx/1" />{' '}
            <span className="signup-form__label__discreet">
              <FormattedMessage id="signup/routes/user/form/SignUpFormPassword.tsx/2" />
            </span>
          </div>
          <button
            type="button"
            className="signup-form__seebutton"
            onClick={this.toggleSeeClearPassword}
            data-test-id="toggle-password"
          >
            {this.state.seePassword ? 'Masquer' : 'Afficher'}
          </button>
        </div>
        <input
          id="input-password"
          data-test-id="input-password"
          type={this.state.seePassword ? 'text' : 'password'}
          name="password"
          value={this.props.password}
          onChange={this.props.handleChange}
          spellCheck={false}
          required
        />
      </label>
    );
  }
}
